// import { Navigate } from "react-router-dom";
// import { useAuth } from "../auth/AuthContext";

// export default function ProtectedRoute({ children }) {
//   const { user } = useAuth();
//   if (!user) {
//     return <Navigate to="/" replace />;
//   }
//   return children;
// }


import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Remember where they were trying to go (e.g. a "view your evaluation"
    // email link) so login can send them back here instead of the default
    // post-login destination.
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}